import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./sidebar";
import { useEffect, useState } from "react";
import axios from "axios";

const ProtectedRouteMachine = () => {
  const location = useLocation();
  const [isMachineValid, setIsMachineValid] = useState(null);

  const checkIfDeviceIsValid = async () => {
    const companyCode = localStorage.getItem("masterCompanyCode") || "-";
    const pubKey = localStorage.getItem("companyPublicKey") || "-";
    const privKey = localStorage.getItem("companyPrivateKey") || "-";

    try {
      const url = `https://cubixweberp.com:199/CheckStatus?cmpcode=${companyCode}&publick=${pubKey}&privatek=${privKey}`;
      const res = await axios.get(url);

      const isValid =
        res.data?.length > 0 && res.data[0].Column1 === "VALIDATED";
      setIsMachineValid(isValid);
    } catch (err) {
      // setIsMachineValid(false);
    }
  };

  useEffect(() => {
    checkIfDeviceIsValid();
  }, [location.pathname]); // Only re-check when the actual path changes

  if (isMachineValid === null) {
    return <div className="loading-screen">Validating Device...</div>;
  }

  return isMachineValid ? (
    <Outlet />
  ) : (
    <Navigate to="/machine_registration" state={{ from: location }} replace />
  );
};

export default ProtectedRouteMachine;
